export default function MaterialsShowcase() {
  const materials = [
    {
      name: 'Granite Countertops',
      description: 'Natural stone with unique patterns, exceptional durability, and heat resistance. Perfect for busy kitchens.',
      features: ['Heat resistant', 'Unique patterns', 'Long-lasting', 'Adds home value'],
      priceRange: '$40-$100 per sq ft',
      image: 'https://public.readdy.ai/ai/img_res/1a6bac8c11669c75f00f15d2d5251d19.jpg'
    },
    {
      name: 'Quartz Countertops',
      description: 'Engineered stone offering consistent patterns, non-porous surface, and low maintenance requirements.',
      features: ['Non-porous', 'Stain resistant', 'Low maintenance', 'Consistent patterns'],
      priceRange: '$50-$120 per sq ft',
      image: 'https://readdy.ai/api/search-image?query=Premium%20quartz%20countertop%20surface%20with%20uniform%20elegant%20pattern%2C%20smooth%20engineered%20stone%20with%20consistent%20coloring%2C%20bright%20natural%20lighting%20showing%20flawless%20finish%2C%20modern%20kitchen%20surface%20with%20subtle%20veining%2C%20emphasis%20on%20contemporary%20design%20and%20durability&width=500&height=350&seq=quartz-material-001&orientation=landscape'
    },
    {
      name: 'Marble Countertops',
      description: 'Timeless elegance with distinctive veining, ideal for bathrooms and low-traffic kitchen areas.',
      features: ['Elegant appearance', 'Cool surface', 'Classic beauty', 'Unique veining'],
      priceRange: '$50-$150 per sq ft',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20marble%20countertop%20with%20dramatic%20natural%20veining%20patterns%2C%20elegant%20white%20and%20gray%20stone%20surface%2C%20sophisticated%20lighting%20highlighting%20unique%20geological%20formations%2C%20classic%20bathroom%20or%20kitchen%20surface%20with%20polished%20finish%2C%20emphasis%20on%20timeless%20beauty%20and%20luxury&width=500&height=350&seq=marble-material-001&orientation=landscape'
    },
    {
      name: 'Quartzite Countertops',
      description: 'Natural stone harder than granite with marble-like appearance, combining beauty and durability.',
      features: ['Extremely durable', 'Heat resistant', 'Natural beauty', 'UV resistant'],
      priceRange: '$60-$120 per sq ft',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20quartzite%20countertop%20surface%20with%20natural%20stone%20patterns%2C%20hard%20durable%20material%20with%20elegant%20appearance%2C%20bright%20lighting%20showing%20unique%20geological%20characteristics%2C%20premium%20kitchen%20surface%20combining%20strength%20and%20beauty%2C%20emphasis%20on%20natural%20stone%20quality%20and%20sophistication&width=500&height=350&seq=quartzite-material-001&orientation=landscape'
    }
  ];

  return (
    <section id="materials" className="py-20 bg-gradient-to-br from-gray-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Popular Countertop Materials in El Paso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore the best countertop materials for your kitchen or bathroom renovation project.
          </p>
        </div>

        <div className="space-y-12">
          {materials.map((material, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-lg overflow-hidden ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } flex flex-col lg:flex`}
            >
              <div className="lg:w-1/2 relative h-80 lg:h-auto">
                <img 
                  src={material.image}
                  alt={material.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-lg shadow-lg">
                  <span className="text-amber-700 font-bold">{material.priceRange}</span>
                </div>
              </div>
              <div className="lg:w-1/2 p-10">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {material.name}
                </h3>
                <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                  {material.description}
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {material.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-amber-700 text-xl"></i>
                      <span className="text-gray-700 font-medium">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
